export const hasMultilineAddress = (form, { excludeEcomAddress } = {
    excludeEcomAddress: false
})=>{
    const fields = [
        ...form?.fields || [],
        ...form?.deletedFields || []
    ];
    return fields.some((field)=>field.view?.fieldType === 'MULTILINE_ADDRESS' || field.view?.fieldType === 'BOOKINGS_ADDRESS' || !excludeEcomAddress && field.view?.fieldType === 'ECOM_ADDRESS');
};

//# sourceMappingURL=has-multiline-address.js.map